export default "__VITE_ASSET__Der1sUHY__"